export default __webpack_public_path__ + "static/media/Fantasy_02.ea90ae0b.png";